module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "l2ie9vc3",
    dataset: process.env.GATSBY_SANITY_DATASET || "production",
  },
  auth: false,
};
